import Vue from 'vue';
import Vuex from 'vuex';
import main from './module/sys/main';
import config from './module/sys/config';
import user from './module/user/index';
import company from './module/company/index';
import chat from './module/chat';
import email from './module/email';
import broadcast from './module/broadcast';
import automation from '@/store/module/automation';
import task from '@/store/module/task';

Vue.use(Vuex);

export default new Vuex.Store<any>({
    mutations: {},
    actions: {},
    modules: {
        main,
        config,
        user,
        company,
        chat,
        email,
        broadcast,
        automation,
        task,
    },
});
